// https://vuex.vuejs.org/en/modules.html

import { default as app } from "./app.js"
import { default as dialog } from "./dialog.js"
import { default as drawer } from "./drawer.js"
import { default as meeting } from "./meeting.js"

export default {
  app,
  dialog,
  drawer,
  meeting
}
